<template>
    <div class="wrapper">
      <div class="btn-toolbar mt-3 justify-content-between" role="toolbar">
        <button @click="saveUser" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
        <button @click="deleteUser" class="btn btn-danger"><font-awesome-icon icon="trash"/>L&ouml;schen</button>
      </div>
      <div class="row">
        <div class="col-md">
          <div class="row mt-3">
            <div class="col-sm">
              <div class="form-group">
                <label>Vorname</label>
                <input class="form-control" v-model="user.firstname"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label>Nachname</label>
                <input class="form-control" v-model="user.lastname"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label>E-Mail</label>
                <input class="form-control" v-model="user.email"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label>Kennung</label>
                <input class="form-control" v-model="user.handid"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label>Unterkennungen</label>
                <input class="form-control" v-model="user.subhandids"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label>Sprache</label>
                <select class="form-control" bind="lang" id="handLang">
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Zugriffsrechte</h5>
                  <div class="form-check">
                    <input id="bshoplogincheck" class="form-check-input" type="checkbox" v-model="user.bshopLogin"/>
                    <label for="bshoplogincheck" class="form-check-label">bShop Login</label>
                  </div>
                  <div class="form-check">
                    <input id="allusercheck" class="form-check-input" type="checkbox" v-model="user.viewallcontacts"/>
                    <label for="allusercheck" class="form-check-label">Alle Kunden</label>
                  </div>
                  <div class="form-check">
                    <input id="freepricecheck" class="form-check-input" type="checkbox" v-model="user.selfprice"/>
                    <label for="freepricecheck" class="form-check-label">Freie Preiseingabe</label>
                  </div>
                  <div class="form-check">
                    <input id="costmanagercheck" class="form-check-input" type="checkbox" v-model="user.costManager"/>
                    <label for="costmanagercheck" class="form-check-label">Kostenstellenmanager</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md">
          <div class="row">
            <div class="col-sm">
              <label>Zusatzfelder</label>
              <div class="wrapper">
                <ul class="list-group">
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-md">
                        <input class="form-control" placeholder="Name" v-model="extrakey" type="text"/>
                      </div>
                      <div class="col-xs"><strong>=</strong></div>
                      <div class="col-md">
                        <input class="form-control" type="text" v-model="extraval" placeholder="Wert"/>
                      </div>
                      <div class="col-xs">
                        <button @click="addExtraField" class="btn btn-primary" name="rempattern"><font-awesome-icon icon="plus"/></button>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item" v-for="(val,key) in user.extras" :key="key">
                    <div class="row">
                      <div class="col-md">
                        <input disabled class="form-control" placeholder="Name" :value="key" type="text"/>
                      </div>
                      <div class="col-xs"><strong>=</strong></div>
                      <div class="col-md">
                        <input class="form-control" type="text" v-model="user.extras[key]" placeholder="Wert"/>
                      </div>
                      <div class="col-xs">
                        <button @click="remExtraField(key)" class="btn btn-danger" name="rempattern"><font-awesome-icon icon="trash"/></button>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm">
              <div class="form-group">
                <label>Datenfilter</label>
                <textarea class="form-control" cols="35" rows="6" v-model="user.productfilter">
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import router from '@/router'
import ihanduser from '@/modules/ihanduser.js'

export default {
  name: 'iHandUserEntry',
  props:["userid"],
  data() {
    return {
      user: {},
      extraval: '',
      extrakey: '',
    }
  },
  mounted: function() {
    if (this.userid != -1)
      this.fetchData();
    else
      this.user.id = 0;
  },
  methods: {
    addExtraField() {
      console.log('add ef: ' + this.extrakey);
      if (this.extrakey === '') {
        this.$bvToast.toast('Bitte erst einen kurzen Namen für das Extrafeld eingeben.',{title:'Aussendienst',variant:'warning'})
        return;
      }
      // vue and bad data design workaround :(
      var temp = JSON.parse(JSON.stringify(this.user.extras || {}));
      temp[this.extrakey] = this.extraval;
      this.user.extras = temp;
      this.extrakey = '';
      this.extraval = '';
    },
    remExtraField(key) {
      console.log('rem extra: ' + key);
      // vue and bad data design workaround :(
      var temp = JSON.parse(JSON.stringify(this.user.extras || {}));
      delete temp[key];
      this.user.extras = temp;
      console.log(temp);
    },
    saveUser: function() {
      var self = this;
      var lback = this.user.login;
      console.log('Save: ' + this.user);
      ihanduser.save(this,this.user,function(data) {
        console.log(data);
        self.user = data;
        self.user.login = lback;
        self.$emit('loaded',data);
        self.$bvToast.toast('Vertreter gespeichert',{title:'Aussendienst',variant:'success'});
      })
    },
    deleteUser: function() {
      if (!this.user || this.user.id === 0) {
        return;
      }

      if (confirm('Möchten Sie wirklich den Verteter "' + this.user.firstname + ' ' + this.user.lastname + ' (' + this.user.id + ')" löschen?')) {
        var self = this;
        ihanduser.deleteUser(this,this.user.id,function() {
          self.$bvToast.toast('Vertreter wurde gelöscht!',{title:'Vertreter',variant: 'success'});
          router.push({name: 'iHandUserList',params: {}});
        });
      }

    },
    fetchData() {
      var self = this;
      ihanduser.load(this,this.userid,function(data) {
        self.user = data;
        self.$emit('loaded',data);
      })
    }
  }
}
</script>
